module.exports = __webpack_public_path__ + "img/pageRight.5e289fc5.svg";